import { module } from 'angular';
import { GmcRecaptchaService } from './gmc-recaptcha.service';
import { gmcRecaptchaDirective } from './gmc-recaptcha.directive';
import { GmcRecaptchaProvider } from './gmc-recaptcha.provider';

export const GmcRecaptchaModule = module('app.shared.directives.gmc-recaptcha', [])
  .provider(GmcRecaptchaService.name, GmcRecaptchaProvider)
  .directive('gmcRecaptcha', gmcRecaptchaDirective);



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-recaptcha/gmc-recaptcha.module.ts